import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=283678ae&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=js&"
export * from "./TextArea.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TextArea.vue?vue&type=style&index=0&id=283678ae&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "283678ae",
  "72ca9a0b"
  
)

export default component.exports